"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const person_1 = require("./person");
const loader_1 = require("./loader");
const NoImage = (0, styled_components_1.default)(person_1.Person) `
  display: block;
  margin: auto;
`;
const Wrapper = styled_components_1.default.div `
  width: ${({ size }) => (size === "normal" ? 48 : 128)}px;
  height: ${({ size }) => (size === "normal" ? 48 : 128)}px;
  font-size: ${({ size }) => (size === "normal" ? 34 : 76)}px;
  border-radius: 50%;
  display: flex;
  justify-content: center
  align-items: center;
  background-color: ${({ theme }) => theme.neutral.light};
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
`;
const Image = styled_components_1.default.img `
  display: flex;
  object-fit: cover;
  width: 100%;
  border-radius: 50%;
`;
const RotaAvatar = (_a) => {
    var { isLoading, src, size = "normal" } = _a, props = __rest(_a, ["isLoading", "src", "size"]);
    if (isLoading)
        return react_1.default.createElement(loader_1.AvatarLoader, { size: size });
    return (react_1.default.createElement(Wrapper, Object.assign({ size: size, hasImage: !!src }, props), src ? react_1.default.createElement(Image, { src: src }) : react_1.default.createElement(NoImage, null)));
};
exports.default = RotaAvatar;
